import { render, staticRenderFns } from "./AddGroupMember.vue?vue&type=template&id=bd2aa200&"
import script from "./AddGroupMember.vue?vue&type=script&lang=js&"
export * from "./AddGroupMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports